import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import trial1 from '../../images/trial1.png';
import trial2 from '../../images/trial2.png';
import trial3 from '../../images/trial3.png';
import user from '../../images/user.png';
import email from '../../images/email.png';
import phone from '../../images/phone.png';
import company from '../../images/company.png';
import country from '../../images/country.png';
import bed from '../../images/bed.png';

const TrialFrom = (props) => {

    const [isOpen, setOpen] = useState(false)

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="trial_section section_space">
            <div className="container">
                <div className="row">
                   <div className="col-lg-12 text-center">
                       <h2>Try Little Hotel Ex. Free for 14 Days.</h2>
                       <p className='mb-0'>No lock-in contracts. Cancel anytime</p>
                       <p className='mb-0'>Just fill in this quick form:</p>
                    </div>

                    <div className="col-lg-5">
                          <div className='trial_form_inside'>
                                <h3>Powerful hotel management <br/> software. Your way.</h3>
                                <div className='trial_form_inside_item'><img src={trial1}/> <p><b>Boost your bookings</b> by up to 46% with our simple software.</p></div>
                                <div className='trial_form_inside_item'><img src={trial2}/> <p><b>Take back control</b> of all your check-ins, bookings and invoices in one place.</p></div>
                                <div className='trial_form_inside_item'><img src={trial3}/> <p><b>Enjoy more freedom </b> to manage your property on-the-go with our mobile app.</p></div>
                          </div>
                    </div>
                    <div className="col-lg-7">
                        <form className="trial_form">
                           <div className="form-group">
                                <img src={user} alt="User" />
                                <input type="text" placeholder="First Name" className="form-control"/>
                            </div>
                            <div className="form-group">
                                <img src={user} alt="User" />
                                <input type="text" placeholder="Last Name"  className="form-control"/>
                            </div>
                            <div className="form-group">
                               <img src={email} alt="User" />
                                <input type="email" placeholder="Email Address"  className="form-control"/>
                            </div>
                            <div className="form-group">
                               <img src={phone} alt="User" />
                                <input type="text" placeholder="Phone Number" className="form-control" />
                            </div>
                            <div className="form-group">
                               <img src={company} alt="User" />
                                <input type="text" placeholder="Company name" className="form-control" />
                            </div>
                            <div className="form-group">
                            <img src={bed} alt="User" />
                                <input type="text" placeholder="Number of Rooms" className="form-control" />
                            </div>
                            <div className="form-group">
                            <img src={country} alt="User" />
                                <input type="text" placeholder="Select your Country" className="form-control" />
                            </div>

                            <div className="form-group">
                                <textarea placeholder="Comments" className="form-control"></textarea>
                            </div>

                            <ul className='unordered_list p-0 justify-content-start'>
                                <li>
                                    <Link onClick={ClickHandler} className='btn' to="/pricing"><span className='btn_label' data-text='Try For Free'>Try For Free</span></Link>
                                </li>
                            </ul>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TrialFrom;